import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";
import { AREAS, EASE } from "./data";

export const ServiceArea = () => (
  <section data-testid="area-section" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-36">
    <div className="grid gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <SectionLabel index="06">Service area</SectionLabel>
        <h2 className="font-display text-5xl font-black uppercase leading-[0.9] sm:text-6xl">Queen City<br />coverage.</h2>
        <p className="mt-6 font-mono text-sm text-zinc-400">35.2271° N · 80.8431° W</p>
        <p className="mt-6 max-w-sm text-base leading-relaxed text-zinc-300">Based in Charlotte, NC. Not sure if we cover your property? Call — we'll tell you straight.</p>
      </Reveal>
      <ul className="flex flex-wrap content-start gap-3 lg:col-span-7">
        {AREAS.map((a, i) => (
          <motion.li
            key={a}
            data-testid={`area-${a.replace(/\s/g, "-").toLowerCase()}`}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.6, ease: EASE, delay: i * 0.04 }}
            whileHover={{ y: -3 }}
            className="cursor-default border border-[var(--line)] px-5 py-3 font-display text-2xl font-extrabold uppercase transition-[border-color,color] duration-300 hover:border-[var(--signal)] hover:text-[var(--signal)] sm:text-4xl"
          >
            {a}
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);
